module.exports = __webpack_public_path__ + "static/media/si.06cc015d.svg";